import useAsyncData from "../../../../hooks/use-async-data";
import orderService from "../../order.service";
import OrderTransportingOrderAvailableConsumers from "./order-transporting-order-available-consumers";
import OrderTransportingOrderAvailableConsumersParams from "./order-transporting-order-available-consumers-params";

const useOrderTransportingOrderAvailableConsumers = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<OrderTransportingOrderAvailableConsumers>([], false);

  const load = async (
    params: OrderTransportingOrderAvailableConsumersParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const orderTransportingOrderAvailableConsumers =
        await orderService.getTaxiAvailableConsumers(params, signal);

      setData(orderTransportingOrderAvailableConsumers);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useOrderTransportingOrderAvailableConsumers;
